var patterns = {
    smallCubes: "<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'><g fill-rule='evenodd'><g id='Artboard-5' fill='#1C140D' fill-opacity='0.04' fill-rule='nonzero'><path d='M6 18h12V6H6v12zM4 4h16v16H4V4z'/></g></g></svg>"
}

export default patterns
